import React from 'react';
import { useSelector } from 'react-redux';

import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';

import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

import './FeaturedSection.scss';

function FeaturedSection() {
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const mobileTitleText = 'So many ways to elevate your shop-to-earn experience';
  const tabletAndDesktopTitleText = 'Features to elevate your shopping and earning experience';
  const titleText = isMobileMQ ? mobileTitleText : tabletAndDesktopTitleText;

  return (
    <div className="mn_featuredSection">
      <ContentWrap>
        <SectionTitle title={titleText} />
        <div className="mn_featuredItems">
          <div className="mn_featuredItem">
            <div className="mn_featuredItemContent">
              <div className="mn_icon mn_moneyIcon" />
              <h3 className="mn_featuredItemHeader">Totally free</h3>
              <p className="mn_featuredItemInfo">
                No membership costs or hidden fees. Simply earn miles on shopping you're already doing.
              </p>
            </div>
          </div>

          <div className="mn_featuredItem">
            <div className="mn_featuredItemContent">
              <div className="mn_icon mn_cardIcon" />
              <h3 className="mn_featuredItemHeader">Cardmembers earn more</h3>
              <p className="mn_featuredItemInfo">
                Shop with your United MileagePlus credit card to earn additional miles.
              </p>
            </div>
          </div>

          <div className="mn_featuredItem">
            <div className="mn_featuredItemContent">
              <div className="mn_icon mn_basketIcon" />
              <h3 className="mn_featuredItemHeader">Perks, perks, perks</h3>
              <p className="mn_featuredItemInfo">
                Great deals, valuable coupon codes,
                seasonal sales and free shipping promotions &ndash; they're all here.
              </p>
            </div>
          </div>
        </div>
      </ContentWrap>
    </div>
  );
}

export default FeaturedSection;
